var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { pageImages } from '@/pages/images';
import { StepLayout } from './step-layout.component';
import { TextField } from 'hx-ui';
export function ReferenceNumber() {
    return (_jsx(StepLayout, { image: pageImages.womanWithTablet, showProgress: false, heading: "Saisissez le num\u00E9ro", subHeading: "de votre dossier", content: _jsx("div", __assign({ className: "flex flex-col items-center justify-center gap-16 w-full" }, { children: _jsx(TextField, { name: "reference-number", variant: "standard", className: "w-[326px] sm:w-[442px] md:w-[326px]", label: "# Num\u00E9ro de r\u00E9f\u00E9rence", autoComplete: "off", sx: {
                    '& .MuiInput-underline:before': {
                        borderBottomColor: function (theme) { return theme.palette.secondary.main; },
                    },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                        borderBottomColor: function (theme) { return theme.palette.secondary.main; },
                    },
                }, inputProps: {
                    maxLength: 5,
                }, rules: {
                    required: 'Le numéro de référence est requis',
                    pattern: {
                        value: /^\d+$/,
                        message: 'Le numéro de référence doit être numérique (ex. : 00000)',
                    },
                    minLength: {
                        value: 5,
                        message: 'Le numéro de référence doit comporter au moins 5 caractères',
                    },
                } }) })) }));
}
